import { IPublicClientApplication } from "@azure/msal-browser";
import { axiosGetRequest } from "../../api/ApiClient";
import GenericUtils from "../../utils/GenericUtils";

export interface IDocFilter {
    teacherId?: number | string;
    initialDate?: any;
    finalDate?: any;
    year?: string;
}

const route = "/docente/v1/";
const pathDocument = `${route}documentotaches?orderBy=dtSubmissaoAprovacao&SortOrder=DESCENDING&query=subProcessoJustificativaTachStatus = "DONE"`;

const generateHistoricFilter = (filter: IDocFilter) => {
    let path = `${pathDocument} and subProcessoJustificativaTach(docente(id = ${filter.teacherId}))`;

    if (filter.year) {
        path += ` and processoTach(vigencia(ano = ${filter.year}))`;
    }

    if (filter.initialDate && filter.finalDate) {
        path += ` and subProcessoJustificativaTach(created date:${filter.initialDate}...date:${filter.finalDate})`;
    }

    return path;
};

const getListDocuments = (
    instance: IPublicClientApplication,
    filter: IDocFilter
) => {
    const path = filter && generateHistoricFilter(filter);

    return axiosGetRequest(
        path ?? pathDocument,
        GenericUtils.getAccessTokenDocente(),
        instance
    );
};

const getAllTeachers = (instance: IPublicClientApplication) => {
    const user = GenericUtils.getUser();

    const path =
        user.isCord && !user.isDac && !user.isJuri
            ? `${route}professores?&_limit=999999&matricula_coordenador=${user?.docente?.matriculaAdp}`
            : `${route}professores?&_limit=999999`;

    return axiosGetRequest(
        path,
        GenericUtils.getAccessTokenDocente(),
        instance
    );
};

const getSignedUrlDocument = (
    instance: IPublicClientApplication,
    docId: string,
    attachment: boolean
) => {
    return axiosGetRequest(
        `${route}/documentotaches/${docId}?anexo=${attachment}`,
        GenericUtils.getAccessTokenDocente(),
        instance
    );
};

const filterDocuments = (documents: any[], years: number[]) => {
    return documents.filter((document) => {
        const documentYear = new Date(document.vigencia).getFullYear();
        return years.includes(documentYear);
    });
};

const getAllPeriods = (instance: IPublicClientApplication, id: any) => {
    return axiosGetRequest(
        `${route}docentes/${id}/vigencias`,
        GenericUtils.getAccessTokenDocente(),
        instance
    );
};

const postPrintAllDocuments = (
    instance: IPublicClientApplication,
    docenteId: number,
    periodId: string
) => {
    return axiosGetRequest(
        `${route}docentes/${docenteId}/downloaddocumentos?ids=${periodId}`,
        GenericUtils.getAccessTokenDocente(),
        instance
    );
};

export {
    getAllTeachers,
    getListDocuments,
    getSignedUrlDocument,
    getAllPeriods,
    postPrintAllDocuments,
    filterDocuments,
};
